import {Surcharge, SurchargeableClassname, surchargeByIdAsofTqo} from "../rpc/webrpc-client.gen.ts";
import {z} from "zod/v4";
import {Flexidate, spawnTstzSpan, stringify} from "../tstzspan.ts";
import {InfallibleUseResult, pendingUseResult, successUseResult} from "../util/hookutil.tsx";
import {useInfallibleQuery} from "../util/useInfallibleQuery.tsx";
import {useMothership} from "../tq/tqx.tsx";

export const UseSurchargeAsofArgs = z.object({
    subjectClass: SurchargeableClassname,
    surchargeId: z.string(),
    asof: z.optional(Flexidate),
});
export type UseSurchargeAsofArgs = z.infer<typeof UseSurchargeAsofArgs>;

export const UseSurchargeAsofReturn = z.object({
    surcharge: z.nullable(Surcharge),
    isActive: z.boolean(),
});
export type UseSurchargeAsofReturn = z.infer<typeof UseSurchargeAsofReturn>;

export function useSurchargeAsof(args ?: UseSurchargeAsofArgs): InfallibleUseResult<UseSurchargeAsofReturn> {
    const mama = useMothership();
    const tqargs = args
        ? {
            subjectClass: args.subjectClass,
            surchargeId: args.surchargeId,
            asof: stringify(args.asof ?? new Date())
        } as const
        : undefined;
    const tqrv = useInfallibleQuery(surchargeByIdAsofTqo(mama, tqargs));
    if (tqrv.isPending) {
        return pendingUseResult;
    }
    let isActiveAsof = false;
    const relevantRevision = tqrv.data ?? null;
    if (relevantRevision) {
        const validSpan = spawnTstzSpan(relevantRevision.validSpan);
        const now = new Date();
        isActiveAsof = validSpan.contains(now);
    }
    return successUseResult({
        surcharge: relevantRevision,
        isActive: isActiveAsof,
    });
}


